import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const breadcrumbMap: Record<string, BreadcrumbItem[]> = {
  '/': [{ label: '首页' }],
  '/about': [{ label: '首页', href: '/' }, { label: '关于我们' }],
};

function getBreadcrumbs(pathname: string): BreadcrumbItem[] {
  if (breadcrumbMap[pathname]) return breadcrumbMap[pathname];

  if (pathname.startsWith('/category/')) {
    const slug = pathname.split('/')[2];
    const categoryNames: Record<string, string> = {
      movie: '电影',
      tv: '电视剧',
      anime: '动漫',
      variety: '综艺',
    };
    return [
      { label: '首页', href: '/' },
      { label: categoryNames[slug] || slug },
    ];
  }

  if (pathname.startsWith('/article/')) {
    return [
      { label: '首页', href: '/' },
      { label: '文章详情' },
    ];
  }

  return [{ label: '首页', href: '/' }];
}

export default function Breadcrumb() {
  const location = useLocation();
  const items = getBreadcrumbs(location.pathname);

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap text-sm text-foreground-600">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <span className="mx-2 text-foreground-400">/</span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}